import { datadogRum } from "@datadog/browser-rum";

export function init(env, appId, token, sampleRate=5, premiumSampleRate=0){
  if (env !== "development") {
    datadogRum.init({
      applicationId: appId,
      clientToken: token,
      site: "datadoghq.com",
      service: "spotcrm-india",
      version: "1.0.0",
      sampleRate: sampleRate,
      premiumSampleRate: premiumSampleRate,
      trackInteractions: true,
      silentMultipleInit: true,
      defaultPrivacyLevel: "allow",
      trackSessionAcrossSubdomains: true,
    });
  }
}

export function startRecording() {
  datadogRum.startSessionReplayRecording();
}

startRecording()
export function stopRecording() {
  datadogRum.stopSessionReplayRecording();
}
